@if (mode === 'hardware') {
  <form [formGroup]="hardwareForm" class="hardware-form">
    <div class="top-grid">
      <div class="form-field">
        <p-floatLabel>
          <p-dropdown
            appendTo="body"
            scrollHeight="400px"
            [options]="courses"
            optionLabel="courseName"
            optionValue="courseId"
            formControlName="courseId"
            [filter]="true"
            [showClear]="true"
          >
            <ng-template pTemplate="selectedItem" let-item>
              {{ item?.courseName || "— Keine Auswahl —" }}
            </ng-template>

            <ng-template pTemplate="item" let-item>
              {{ item.courseName }}
            </ng-template>
          </p-dropdown>
          <label>Kurs</label>
        </p-floatLabel>
      </div>

      <div class="form-field">
        <p-floatLabel>
          <p-dropdown
            appendTo="body"
            scrollHeight="400px"
            [options]="participants"
            optionLabel="fullName"
            optionValue="id"
            formControlName="participant"
            [filter]="true"
            [showClear]="true"
          >
            <ng-template pTemplate="selectedItem" let-item>
              {{ item?.fullName || "— Keine Auswahl —" }}
            </ng-template>

            <ng-template pTemplate="item" let-item>
              {{ item.fullName }}
            </ng-template>
          </p-dropdown>
          <label>Teilnehmer</label>
        </p-floatLabel>
      </div>

      <div class="form-field required-field">
        <p-floatLabel>
          <p-dropdown
            appendTo="body"
            scrollHeight="400px"
            [options]="hardwareCategories"
            optionLabel="name"
            optionValue="id"
            formControlName="hardwareCategory"
          ></p-dropdown>
          <label>Kategorie*</label>
        </p-floatLabel>
        @if (
          hardwareForm.get('hardwareCategory')?.hasError('required') &&
          hardwareForm.get('hardwareCategory')?.touched
        ) {
          <small class="p-error">❌ Kategorie ist erforderlich.</small>
        }
      </div>

      <div class="form-field">
        <p-floatLabel>
          <p-dropdown
            scrollHeight="400px"
            formControlName="status"
            [options]="statusOptions"
            optionLabel="label"
            optionValue="value"
            placeholder="Status auswählen"
          >
          </p-dropdown>
          <label>Status</label>
        </p-floatLabel>
      </div>

      <div class="form-field">
        <p-floatLabel>
          <p-calendar
            #startCal
            formControlName="startDate"
            dateFormat="dd.mm.yy"
            [showIcon]="true"
            [showOnFocus]="false"
            [readonlyInput]="true"
            appendTo="body"
            panelStyleClass="inventory-calendar-panel"
            (onShow)="onStartCalendarShow()"
            (onHide)="onStartCalendarHide()"
          ></p-calendar>
          <label>Startdatum</label>
        </p-floatLabel>
      </div>

      <div class="form-field">
        <p-floatLabel>
          <p-calendar
            #endCal
            formControlName="endDate"
            dateFormat="dd.mm.yy"
            [showIcon]="true"
            [showOnFocus]="false"
            [readonlyInput]="true"
            appendTo="body"
            panelStyleClass="inventory-calendar-panel"
            (onShow)="onEndCalendarShow()"
            (onHide)="onEndCalendarHide()"
          ></p-calendar>
          <label>Enddatum</label>
        </p-floatLabel>
      </div>

      <div class="form-field checkbox-field">
        <p-checkbox
          inputId="returned"
          [binary]="true"
          formControlName="returned"
        >
        </p-checkbox>

        <label for="returned">Zurückgegeben</label>
      </div>

      <!-- Buch Versand nur fuer Buecher -->
      @if (selectedKind === 'BOOK') {
        <div class="form-field">
          <p-floatLabel>
            <p-dropdown
              scrollHeight="400px"
              formControlName="buchVersandStatus"
              [options]="[
                { label: 'Versendet', value: 'Versendet' },
                { label: 'Nicht versendet', value: 'Nicht versendet' },
              ]"
            >
            </p-dropdown>

            <label>Buch Versand</label>
          </p-floatLabel>
        </div>
      }

      <div class="form-field">
        <p-floatLabel>
          <input pInputText formControlName="department" />
          <label>Abteilung</label>
        </p-floatLabel>
      </div>

      <div class="form-field">
        <p-floatLabel>
          <input pInputText formControlName="location" />
          <label>Standort</label>
        </p-floatLabel>
      </div>
    </div>

    <!-- Anmerkungen -->
    <div class="form-group note-group full-width">
      <div class="note-header">
        <label class="note-label">Anmerkungen</label>
        <span class="note-hint">Optionale Zusatzinformationen zum Inventar</span>
      </div>

      @if (isBrowser) {
        <div class="note-editor-wrapper">
          <quill-editor
            [modules]="quillModules"
            [formats]="quillFormats"
            formControlName="note"
          ></quill-editor>
        </div>
      }
    </div>

    <!-- BUCH -->
    @if (selectedKind === 'BOOK') {
      <div class="dynamic-grid">
        <div class="form-field">
          <p-floatLabel>
            <p-dropdown
              appendTo="body"
              scrollHeight="400px"
              [options]="books"
              optionLabel="title"
              optionValue="title"
              formControlName="model"
              [filter]="true"
              [editable]="true"
              [showClear]="true"
            ></p-dropdown>
            <label>Buchtitel</label>
          </p-floatLabel>
        </div>
      </div>
    }

    <!-- TECHNIK -->
    @if (selectedKind === 'TECH') {
      <div class="dynamic-grid">
        <div class="form-field required-field">
          <p-floatLabel>
            <input pInputText formControlName="model" />
            <label>Modell*</label>
          </p-floatLabel>
          @if (
            hardwareForm.get('model')?.hasError('required') &&
            hardwareForm.get('model')?.touched
          ) {
            <small class="p-error">❌ Modell ist erforderlich.</small>
          }
        </div>

        <div class="form-field required-field">
          <p-floatLabel>
            <input
              pInputText
              formControlName="serialNumber"
              (blur)="onSerialBlur()"
            />
            <label>Seriennummer*</label>
          </p-floatLabel>

          @if (
            hardwareForm.get('serialNumber')?.hasError('required') &&
            hardwareForm.get('serialNumber')?.touched
          ) {
            <small class="p-error">❌ Seriennummer ist erforderlich.</small>
          }

          @if (
            hardwareForm.get('serialNumber')?.hasError('serialExists') &&
            hardwareForm.get('serialNumber')?.touched
          ) {
            <small class="p-error"
              >❌ Diese Seriennummer existiert bereits.</small
            >
          }
        </div>

        <div class="form-field">
          <p-floatLabel>
            <input pInputText formControlName="assetTag" />
            <label>Asset-Tag</label>
          </p-floatLabel>
        </div>

        <div class="form-field">
          <p-floatLabel>
            <input pInputText formControlName="puk2" autocomplete="off" />
            <label>PUK2</label>
          </p-floatLabel>
        </div>

        <div class="form-field">
          <p-floatLabel>
            <input
              pInputText
              formControlName="adminBenutzername"
              autocomplete="off"
            />
            <label>Admin Benutzername</label>
          </p-floatLabel>
        </div>

        <div class="form-field">
          <p-floatLabel>
            <input
              pInputText
              formControlName="adminPasswort"
              autocomplete="off"
            />
            <label>Admin Passwort</label>
          </p-floatLabel>
        </div>

        <div class="form-field">
          <p-floatLabel>
            <input pInputText formControlName="passwort" autocomplete="off" />
            <label>Passwort</label>
          </p-floatLabel>
        </div>

        <div class="performance-box">
          <div class="performance-header">
            <div class="performance-title">
              <h4>Leistungsdaten</h4>
              <small class="performance-hint">
                Bezeichnung (z. B. GPU, OS)
              </small>
            </div>

            <button
              pButton
              type="button"
              icon="pi pi-plus"
              label="Zeile hinzufügen"
              class="p-button-sm p-button-text"
              (click)="addPerformanceRow()"
            ></button>
          </div>

          <div formArrayName="performanceItems" class="performance-list">
            @for (row of performanceItems.controls; track $index) {
              <div class="performance-row" [formGroupName]="$index">
                <div class="form-field">
                  <input
                    pInputText
                    formControlName="key"
                    placeholder="z. B. GPU, OS"
                  />
                </div>

                <div class="form-field">
                  <p-floatLabel>
                    <input pInputText formControlName="value" />
                    <label>Wert</label>
                  </p-floatLabel>
                </div>

                <button
                  pButton
                  type="button"
                  icon="pi pi-trash"
                  class="p-button-danger p-button-text p-button-icon-only"
                  (click)="removePerformanceRow($index)"
                  aria-label="Löschen"
                ></button>
              </div>
            }
          </div>
        </div>
      </div>
    }

    <!-- BUTTONS -->
    <div class="form-buttons">
      <button
        pButton
        type="button"
        icon="pi pi-save"
        label="Speichern"
        class="p-button-success"
        [disabled]="hardwareForm.invalid"
        (click)="submit()"
      ></button>

      <button
        pButton
        type="button"
        icon="pi pi-times"
        label="Abbrechen"
        class="p-button-secondary"
        (click)="close()"
      ></button>
    </div>
  </form>
}

@if (mode === 'category') {
  <form [formGroup]="categoryForm" class="category-form">
    <div class="form-field required-field">
      <p-floatLabel>
        <input pInputText formControlName="name" />
        <label>Kategoriename*</label>
      </p-floatLabel>
      @if (
        categoryForm.get('name')?.hasError('required') &&
        categoryForm.get('name')?.touched
      ) {
        <small class="p-error">❌ Kategoriename ist erforderlich.</small>
      }
    </div>

    <div class="form-buttons">
      <button
        pButton
        type="button"
        icon="pi pi-save"
        label="Speichern"
        aria-label="Speichern"
        class="p-button-success"
        (click)="submit()"
      ></button>

      <button
        pButton
        type="button"
        icon="pi pi-times"
        label="Abbrechen"
        aria-label="Abbrechen"
        class="p-button-secondary"
        (click)="close()"
      ></button>
    </div>
  </form>
}
